// export this package's api
import ListView from './ListView';
import IndexedList from './Indexed';

ListView.IndexedList = IndexedList;
var DataSource = ListView.DataSource;

export { DataSource, IndexedList };
export default ListView;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-list-view/es/index.js
// module id = 108
// module chunks = 0